import { render } from "./ChosenTokens.vue?vue&type=template&id=0df11e84"
import script from "./ChosenTokens.vue?vue&type=script&lang=js"
export * from "./ChosenTokens.vue?vue&type=script&lang=js"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__